import styled, { createGlobalStyle } from "styled-components";
import { Pagination, Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { PaginationContainerProps, PaginationStyledProps } from "./types";

// Global style for Select dropdown in dark mode
export const SelectDropdownGlobalStyle = createGlobalStyle<{ isDarkMode?: boolean }>`
  .ant-select-dropdown {
    background: ${(p) => (p.isDarkMode ? "#2D3748" : "#fff")} !important;
    border: ${(p) => (p.isDarkMode ? "1px solid #4A5568" : "1px solid #d9d9d9")} !important;
    border-radius: 12px !important;
    padding: 8px !important;
    box-shadow: ${(p) => (p.isDarkMode ? "0 4px 12px rgba(0, 0, 0, 0.5)" : "0 4px 12px rgba(0, 0, 0, 0.15)")} !important;
    
    .ant-select-item {
      color: ${(p) => (p.isDarkMode ? "#ffffff" : "#262626")} !important;
      background-color: transparent !important;
      border-radius: 8px !important;
      padding: 10px 12px !important;
      margin: 4px 0 !important;
      
      &:hover:not(.ant-select-item-option-selected) {
        background-color: ${(p) => (p.isDarkMode ? "#4a5568" : "#E6F4FF")} !important;
        color: ${(p) => (p.isDarkMode ? "#ffffff" : "#2D6CCA")} !important;
      }
      
      &.ant-select-item-option-selected {
        background-color: ${(p) => (p.isDarkMode ? "#4a5568" : "#E6F4FF")} !important;
        color: ${(p) => (p.isDarkMode ? "#ffffff" : "#2D6CCA")} !important;
        font-weight: 500 !important;
      }
      
      &.ant-select-item-option-active:not(.ant-select-item-option-selected) {
        background-color: ${(p) => (p.isDarkMode ? "#4a5568" : "#E6F4FF")} !important;
        color: ${(p) => (p.isDarkMode ? "#ffffff" : "#2D6CCA")} !important;
      }
    }
  }
`;

export const PaginationStyled = styled(Pagination)<PaginationStyledProps>`
  padding: ${(p) => p.padding || "0px 0px"};
  text-align: right;
  margin-top: ${(p) => p.marginTop || "0px"};
  border-top: ${(p) => p.borderTop || "0px"};

  .ant-pagination-item {
    min-width: 32px !important;
    height: 32px !important;
    align-items: center;
    background: transparent !important;
    border: 0 !important;
    border-radius: 12px !important;
    display: flex !important;
    justify-content: center;
    margin: 0 4px !important;
    width: 32px !important;

    a {
      align-items: center;
      color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#4e5156")} !important;
      display: flex;
      font-size: 14px !important;
      font-weight: 400 !important;
      height: 100%;
      justify-content: center;
      width: 100%;
    }

    &:hover {
      background: ${(p) => (p.theme === "dark" ? "#4a5568" : "#eee")} !important;

      a {
        color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#222")} !important;
      }
    }
  }

  .ant-pagination-item-active {
    background: ${(p) => (p.theme === "dark" ? "#4a5568" : "#eee")} !important;
    border: 0 !important;

    a {
      color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#222")} !important;
      font-weight: 500 !important;
    }

    &:hover {
      background: ${(p) => (p.theme === "dark" ? "#4a5568" : "#eee")} !important;
    }
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    align-items: center;
    background: transparent !important;
    border: 0 !important;
    border-radius: 12px !important;
    display: flex !important;
    height: 32px !important;
    justify-content: center;
    margin: 0 4px !important;
    min-width: 32px !important;
    width: 32px !important;

    .ant-pagination-item-link {
      align-items: center;
      background: transparent !important;
      background-color: transparent !important;
      border: 0 !important;
      color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#444")} !important;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100%;

      span {
        align-items: center;
        display: flex;
        justify-content: center;
        color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#444")} !important;
      }

      svg {
        color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#444")} !important;
        fill: ${(p) => (p.theme === "dark" ? "#ffffff" : "#444")} !important;
        stroke: ${(p) => (p.theme === "dark" ? "#ffffff" : "#444")} !important;
        font-size: 16px !important;
      }
    }

    &:hover {
      background: ${(p) => (p.theme === "dark" ? "#4a5568" : "#eee")} !important;

      .ant-pagination-item-link {
        background: transparent !important;
        background-color: transparent !important;
        
        svg {
          color: ${(p) => (p.theme === "dark" ? "#ffffff" : "#222")} !important;
          fill: ${(p) => (p.theme === "dark" ? "#ffffff" : "#222")} !important;
          stroke: ${(p) => (p.theme === "dark" ? "#ffffff" : "#222")} !important;
        }
      }
    }

    &.ant-pagination-disabled {
      opacity: 0.5;
      
      .ant-pagination-item-link {
        background: transparent !important;
        background-color: transparent !important;
        color: ${(p) => (p.theme === "dark" ? "#718096" : "#bfbfbf")} !important;
        cursor: not-allowed;

        svg {
          color: ${(p) => (p.theme === "dark" ? "#718096" : "#bfbfbf")} !important;
          fill: ${(p) => (p.theme === "dark" ? "#718096" : "#bfbfbf")} !important;
          stroke: ${(p) => (p.theme === "dark" ? "#718096" : "#bfbfbf")} !important;
        }

        &:hover {
          background: transparent !important;
          background-color: transparent !important;
        }
      }
    }
  }

  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    align-items: center !important;
    background: transparent !important;
    border: 1px solid #0000001a !important;
    border-radius: 12px !important;
    display: flex !important;
    height: 32px !important;
    justify-content: center !important;
    margin: 0 4px !important;
    min-width: 32px !important;
    width: 32px !important;

    .ant-pagination-item-link {
      align-items: center !important;
      background: transparent !important;
      background-color: transparent !important;
      border: 0 !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#444")} !important;
      display: flex !important;
      font-size: 10px !important;
      justify-content: center !important;
      line-height: 1 !important;
      padding: 0 !important;
      text-align: center !important;
      width: 100% !important;
    }

    &:hover {
      background: ${(p) => (p.theme === "dark" ? "#4a5568" : "#eee")} !important;
      border-color: ${(p) => (p.theme === "dark" ? "#718096" : "#0000001a")} !important;

      .ant-pagination-item-link {
        background: transparent !important;
        background-color: transparent !important;
      }
    }
  }
`;

export const PaginationContainer = styled.div<PaginationContainerProps>`
  align-items: center;
  background-color: ${(p) => (p.theme === "dark" ? "transparent" : "#fff")};
  display: flex;
  justify-content: space-between;
  padding: ${(p) => p.padding || "16px 12px"};
`;

export const PaginationLeft = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 8px;
`;

export const CombinedLabel = styled.span<{ theme?: string }>`
  color: ${(p) => (p.theme === "dark" ? "#fff" : "#4e5156")};
  font-size: 14px;
  font-weight: 400;
`;

export const PaginationCenter = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;

  .ant-pagination {
    gap: 4px;
    margin: 0;
  }
`;

export const PaginationRight = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 8px;
  justify-content: flex-end;
  text-align: right;
`;

export const LinesPerPageLabel = styled.span<{ theme?: string }>`
  color: ${(p) => (p.theme === "dark" ? "#fff" : "#4e5156")};
  font-size: 14px;
  font-weight: 400;
`;

export const SelectWrapper = styled.div`
  display: inline-block;
  position: relative;

  .ant-select {
    .ant-select-selector {
      border-radius: 8px !important;
    }
  }
`;

export const StyledSelect = styled(Select)<{ theme?: string }>`
  min-width: 80px;
  width: 80px;

  &.ant-select {
    width: 80px !important;
    height: 34px !important;
    border-radius: 8px !important;
    padding: 0 28px 0 12px !important;
  }

  .ant-select-selector {
    border: 1px solid ${(p) => (p.theme === "dark" ? "#4A5568" : "#d9d9d9")} !important;
    border-radius: 8px !important;
    height: 34px !important;
    padding: 0 28px 0 12px !important;
    transition: all 0.2s ease !important;
    background-color: ${(p) => (p.theme === "dark" ? "#2D3748" : "#fff")} !important;

    .ant-select-selection-item {
      align-items: center !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#4e5156")} !important;
      display: flex !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      justify-content: flex-start !important;
      line-height: 32px !important;
      padding: 0 !important;
    }

    .ant-select-selection-placeholder {
      color: ${(p) => (p.theme === "dark" ? "#8c8c8c" : "#bfbfbf")} !important;
      line-height: 32px !important;
    }
  }

  .ant-select-arrow {
    display: none !important;
  }

  &:hover .ant-select-selector {
    background-color: ${(p) => (p.theme === "dark" ? "#4A5568" : "#f0f0f0")} !important;
    border-color: ${(p) => (p.theme === "dark" ? "#718096" : "#bfbfbf")} !important;
    border-radius: 8px !important;
  }

  &.ant-select-focused .ant-select-selector,
  &:focus .ant-select-selector {
    background-color: ${(p) => (p.theme === "dark" ? "#2D3748" : "#fff")} !important;
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    border-radius: 8px !important;
  }

  &.ant-select-open .ant-select-selector {
    background-color: ${(p) => (p.theme === "dark" ? "#2D3748" : "#fff")} !important;
    border-radius: 8px 8px 0 0 !important;
  }

  /* Dropdown menu styles - Note: This applies to dropdown rendered in SelectWrapper */
  .ant-select-dropdown {
    border-radius: 12px !important;
    padding: 8px !important;
    box-shadow: ${(p) => (p.theme === "dark" ? "0 4px 12px rgba(0, 0, 0, 0.5)" : "0 4px 12px rgba(0, 0, 0, 0.15)")} !important;
    background: ${(p) => (p.theme === "dark" ? "#2D3748" : "#fff")} !important;
    border: ${(p) => (p.theme === "dark" ? "1px solid #4A5568" : "1px solid #d9d9d9")} !important;
  }

  /* Dropdown menu item styles */
  .ant-select-item {
    border-radius: 8px !important;
    padding: 10px 12px !important;
    margin: 4px 0 !important;
    transition: all 0.2s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    
    /* Unselected item styles */
    color: ${(p) => (p.theme === "dark" ? "#fff" : "#262626")} !important;
    background-color: transparent !important;
    border: none !important;
    
    /* Hover state for unselected items */
    &:hover:not(.ant-select-item-option-selected) {
      background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#E6F4FF")} !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
    }
    
    /* Selected item styles */
    &.ant-select-item-option-selected {
      background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#E6F4FF")} !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
      font-weight: 500 !important;
      
      &:hover {
        background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#BAE0FF")} !important;
        color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
      }
    }
    
    /* Active/focus state */
    &.ant-select-item-option-active:not(.ant-select-item-option-selected) {
      background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#E6F4FF")} !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
    }
  }
`;

export const SelectIcon = styled(DownOutlined)<{ theme?: string }>`
  color: ${(p) => (p.theme === "dark" ? "#fff" : "#4e5156")};
  font-size: 12px;
  pointer-events: none;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: color 0.2s ease;
  z-index: 10;
`;


